import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Icon from "@/components/Icon";
import Reveal from "@/components/Reveal";
import { services } from "@/mock/mock";

export default function Services() {
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">Our Services</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-white">
            Full-spectrum security for the modern Canadian enterprise
          </h2>
          <p className="mt-4 text-slate-400">
            From our SOC in Halifax we cover every major segment of data protection and information security.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 80}>
              <Link to="/services" className="group block h-full card-hover rounded-2xl border border-white/10 bg-brand-navy2/60 p-7">
                <div className="flex items-center justify-between">
                  <div className="grid h-12 w-12 place-items-center rounded-xl bg-brand-lime/10 text-brand-lime group-hover:bg-brand-lime group-hover:text-brand-navy transition-colors">
                    <Icon name={s.icon} className="h-6 w-6" />
                  </div>
                  <span className="rounded-full border border-white/10 px-3 py-1 text-[11px] font-medium text-slate-400">{s.tag}</span>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold text-white flex items-center gap-1">
                  {s.title}
                  <ArrowUpRight className="h-4 w-4 text-brand-lime opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.short}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
